import axios from 'axios';

export const getAllUnitUsaha = async () => {
    return await axios.get(`${window._HOST}admin/unitUsaha/`, {withCredentials: true});
}

export const getAllDetailUnitUsaha = async () => {
    return await axios.get(`${window._HOST}admin/unitUsaha/detail`, {withCredentials: true});
}

export const getAllDataTableUnitUsaha = async (searchText = null, offset = 0, limit = 0, $sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/unitUsaha/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/unitUsaha/dataTable?offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const getDropdownUnitUsaha = async () => {
    return await axios.get(`${window._HOST}admin/unitUsaha/dropdown`, {withCredentials: true});
}

export const insertNewUnitUsaha = async (formData) => {
    return await axios.post(`${window._HOST}admin/unitUsaha`, formData, {withCredentials: true});
}

export const updateUnitUsaha = async (formData, id) => {
    return await axios.put(`${window._HOST}admin/unitUsaha/${id}`, formData, {withCredentials: true});
}

export const deleteUnitUsaha = async (id) => {
    return await axios.delete(`${window._HOST}admin/unitUsaha/${id}`, {withCredentials: true});
}

